import { createSonarSelector } from '@lib/selectors';
import { useSonarSelector } from '@hooks';
const selector = createSonarSelector((state) => state.core.followers.byId.read);
export function useFollowingIdReference() {
    const { data } = useSonarSelector(selector);
    return data;
}
